import PropTypes from "prop-types";

const panelPropTypes = {
  dashboardId: PropTypes.any,
  panelId: PropTypes.number,
  options: PropTypes.object,
  loading: PropTypes.bool,
  variables: PropTypes.array,
  displayVariables: PropTypes.array,
  timeRange: PropTypes.object,
  model: PropTypes.object,
  isLoading: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export { panelPropTypes };
